export const riskProfileDeclaration =
  'I hereby consent / I am authorized to consent that Spark Asia Impact Managers Pvt Ltd can use the information provided here to derive the Risk Tolerance score of the Applicant(s)';
export const sectionFilledByInvestor = 'To be filled by investor';
